class PublicMethods{
	verificationPhon(phone){
		// 大陆手机号码11位数，匹配格式：前三位固定格式+后8位任意数
		// 13+任意数 * 15+除4的任意数 * 18+除1和4的任意数 * 17+除9的任意数 * 147
		//  新增了166、198、199号段的手机号
		var reg= /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
		return reg.test(phone);
	}

  getNameAvatar(name) {
    let nameLength = name.length
    let nameWritten = ''
    if (nameLength <= 2) {
      nameWritten = name
    } else {
      let firstName = name.substring(0, 1)
      if (this.isChinese(firstName)) {
        nameWritten = name.substring(nameLength - 2);
      } else {
        let engName = name.substring(0, 2)
        nameWritten = engName.toLocaleUpperCase();
      }
    }
    return nameWritten
  }
  isChinese(temp) {
    var re = /[^\u4E00-\u9FA5]/
    if (re.test(temp)) return false;
    return true;
  }
  currentTime() {
    let date = new Date()
    	const year = date.getFullYear()
    	const month = date.getMonth() + 1
    	const day = date.getDate()
    	const hour = date.getHours()
    	const minute = date.getMinutes()
    	const second = date.getSeconds()
  
    	return `${[year, month, day].map(this.formatNumber).join('/')} ${[hour, minute, second].map(this.formatNumber).join(':')}`
  }
  formatNumber(n) {
    n = n.toString()
    return n[1] ? n : `0${n}`
  }


}

var Utils = new PublicMethods();
export default {
  Utils,
  /*
      功能：设置表格的初始高度，初始不出现纵向滚动条，
      searchBarHeight: 操作栏高度，
      filterHeight: 表格筛选或统计的高度
  */
  setTableHeight: (searchBarHeight, filterHeight) => {
      let winHeight = document.body.clientHeight;
      let tableHeight = winHeight - searchBarHeight - filterHeight - 190-140;
      return tableHeight;
      // return tableHeight < 300 ? 300 : tableHeight;
  },
};



// WEBPACK FOOTER //
// ./src/utils/util.js